import React, { useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  Label,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"

import profile from "assets/images/logo.jpg"
import logo from "assets/images/logo.svg"

import "../../assets/css/Login/Login.css"
import Configs from "../../config"
import secureLocalStorage from "react-secure-storage"
import { FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/loader"

const ForgotPassword = () => {
  const navigate = useNavigate()
  document.title = "Forgot Password | J. Kyle Cleaning Services"

  // ------------------ STATES -------------------
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState("")
  const [error, setError] = useState("")

  // ------------------ HANDLERS -------------------
  const handleChange = e => {
    setEmail(e.target.value)
    setError("") // Clear error on typing
  }

  const validate = () => {
    if (!email) {
      setError("Email is required")
      return false
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address")
      return false
    }
    return true
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!validate()) return

    setLoading(true)

    try {
      const APIData = await FetchPostData(setLoading, "auth/send/otp", {
        email,
      })

      if (APIData?.data?.success) {
        secureLocalStorage.setItem("authCod", {
          email: email,
          code: Number(APIData?.data?.otp),
          id: Number(APIData?.data?.id),
        })

        Swal.fire({
          title: "Success!",
          text:
            APIData?.data?.message ||
            "Password reset link has been sent to your email.",
          icon: "success",
          timer: 3000,
          timerProgressBar: true,
        })

        setTimeout(() => {
          navigate("/verify-code")
        }, 3200)
      } else {
        Swal.fire({
          title: "Failed",
          text:
            APIData?.response?.data?.message ||
            "Something went wrong. Please try again.",
          icon: "error",
        })
      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: "Unable to process request. Please check your connection.",
        icon: "error",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      {loading && <Loader />}

      <div className="login-page">
        <div className="account-pages">
          <Container>
            <Row className="justify-content-end">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-darkblue pe-3">
                    <Row>
                      <Col xs={6}>
                        <div className="text-black p-4 pe-0">
                          <h5 className="text-white fw-bold">
                            Forgot Password?
                          </h5>
                          <p className="text-white">
                            Enter your email to reset <br /> your password
                          </p>
                        </div>
                      </Col>
                      <Col className="col-6 align-self-center">
                        <div className="bg-white p-2">
                          <img
                            src={profile}
                            alt="Forgot Password Illustration"
                            className="img-fluid"
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <CardBody className="pt-0">
                    <div className="text-center">
                      <Link
                        to={`${Configs.appurl}`}
                        className="logo-light-element"
                      >
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img
                              src={logo}
                              alt="Logo"
                              className="rounded-circle"
                              height="34"
                            />
                          </span>
                        </div>
                      </Link>
                    </div>

                    <div className="p-2">
                      <Form onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <Label className="form-label">
                            Email <span className="text-danger">*</span>
                          </Label>
                          <div className="input-group">
                            <Input
                              type="email"
                              placeholder="Enter your email"
                              value={email}
                              onChange={handleChange}
                              invalid={!!error}
                              style={{ borderRadius: "10px" }}
                            />
                          </div>
                          {error && (
                            <span className="text-danger">{error}</span>
                          )}
                        </div>

                        <div className="mt-4 d-grid">
                          <button
                            type="submit"
                            className="btn btn-blue text-white btn-block"
                            disabled={loading}
                          >
                            {loading ? "Sending..." : "Send Reset Code"}
                          </button>
                        </div>

                        <div className="mt-4 text-center">
                          <Link to="/login" className="text-muted">
                            <i className="mdi mdi-chevron-left me-1" />
                            Back to Login
                          </Link>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ForgotPassword
